<svg viewBox="0 0 500 200" fill="currentColor" aria-hidden="true" [class]="sizeClasses()">
  <circle class="mib-dot" cx="72" cy="100" r="30" />
  <circle class="mib-dot" cx="192" cy="100" r="30" />
  <circle class="mib-dot" cx="312" cy="100" r="30" />
  <circle class="mib-dot" cx="432" cy="100" r="30" />
</svg>
